import SingleProduct from './_SingleProduct'
import ProductDetails from './_ProductDetails'
import ProductOrderButton from './_ProductOrderButton'
import CreateProduct from './_CreateProduct'
import Comments from './_Comments'
export default { SingleProduct, ProductDetails, ProductOrderButton, CreateProduct, Comments }
